import React from "react";
import Header from "../../components/Header/Header.tsx";
import Footer from "../../components/Footer/Footer.tsx";
import './SplashPage.scss';


const SplashPage: React.FC = ( )=> {


return (
    <>
    <Header/>
        <div className="welcome-section">
            <div className="welcome-text">
                <h2>Welcome to your new, secure myHealthSpring portal.</h2>
                <p>Let's get you to the right account experience based on your member status</p>
            </div>
            <div className="card-section">
                <div className="card">
                    <h3>Log in to your account</h3>
                    <p>If you are a:</p>
                    <ul>
                        <li>myHealthSpring</li>
                    </ul>
                    <button className="hs-btn">
                        <a className="btn-text" href="https://login.ent-member-test.aws.zilverton.com/authorize?response_type=code&client_id=nmDTuiEz3UFmBKH8DBEOYeyCaPUGlvcK&redirect_uri=https://accounts.uat.healthspring.com&scope=openid&audience=https://customer-test.zilverton-dev.auth0app.com/api/v2/&screen_hint=login">Log in to myHealthSpring</a>
                    </button>
                    <p className="my-hcsc-text">If you are transferring your account from member.healthspring.com and have forgotten your password or username, you will need to reset it <a href="https://member.healthspring.com/">here.</a></p>
                </div>
                <div className="card">
                    <h3>Register your account</h3>
                    <p>Only register a new account if you have recently purchased a HealthSpring plan and are not transferring from HealthSpring Medicare.</p>
                    <button className="hs-btn register-btn">
                        <a className="btn-text" href="https://login.ent-member-test.aws.zilverton.com/authorize?response_type=code&client_id=nmDTuiEz3UFmBKH8DBEOYeyCaPUGlvcK&redirect_uri=https://accounts.uat.healthspring.com&scope=openid&audience=https://customer-test.zilverton-dev.auth0app.com/api/v2/&screen_hint=signup">Register for myHealthSpring</a>
                    </button>
                </div>
            </div>
        </div>
        <div className="join-section">
            <div className="join-text-block">
                <h2>Why join myHealthSpring?</h2>
                <p>We guide you every step, meeting your needs with clear options, helpful tips, and reminders designed around your journey.</p>
                <div className="join-blocks">
                    <div className="join-block">
                        <img className="" src="/static/images/dark-purple_transparent_insurance-card.svg" alt="insurance card icon"/>
                        <p className="join-heading">Download your digital ID cards</p>
                        <p className="join-text">Get 24/7 access to your digital ID card or proof of coverage anywhere, from the web or mobile app.</p>
                    </div>
                    <div className="join-block">
                        <img className="" src="/static/images/dark-purple_transparent_page.svg" alt="page icon"/>
                        <p className="join-heading">Manage your claims online</p>
                        <p className="join-text">Review your most recent claims, their status, and reimbursements.</p>
                    </div>
                    <div className="join-block">
                        <img className="" src="/static/images/dark-purple_transparent_telehealth-monitor.svg" alt="telehealth monitor icon"/>
                        <p className="join-heading">Access virtual care resources</p>
                        <p className="join-text">Find immediate care resources when it matters most. (Net new content. Needs SME input/clarity.)</p>
                    </div>
                </div>
            </div>

            <div>
                <img className="decorative-image" src="/static/images/GettyImages-1170851795_sRGB.jpg" alt="Image of elder couple" />
            </div>
        </div>
        <div className="mobile-app-section">
            <div className="mobile-app-section-text">
                <h2>Keep your wellness on track with the myHealthSpring mobile app.</h2>
                <p>Once you register for myHealthSpring, you get complete access to the mobile app. With easy one-touch, secure sign-on, you can view your digital ID cards, manage your health information, update your profile, and more.</p>
                <p>Explore what HealthSpring has to offer. Every moment you spend here is about your well-being. </p>
                <p className="download-text">Download the myHealthSpring mobile app starting January 1st </p>
            </div>
            <div className="app-store-icons">
                <img className="" src="/static/images/appstore.svg" alt="Apple App Store Badge" />
                <img className="" src="/static/images/googleplay.svg" alt="Google Play Badge" />
                <img className="" src="/static/images/amazon-appstore-badge.png" alt="Amazon App Store Badge" />
            </div>
        </div>
        <div className="registration-help-section">
            <p><strong>Need help with registration or login? </strong>Call 1 (800) 853-2713 (TTY/TDD dial 711)</p>
        </div>
    <Footer />
    </>
);


};

export default SplashPage;
